export default {
  facet: {
    date: {
      custom: "Benutzerdefinierte Daten"
    }
  }
}
